import { render } from "./court-active.vue?vue&type=template&id=565a1549"
import script from "./court-active.vue?vue&type=script&lang=js"
export * from "./court-active.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__